import { render, staticRenderFns } from "./CustomSettings.vue?vue&type=template&id=feb01304&scoped=true"
import script from "./CustomSettings.vue?vue&type=script&lang=js"
export * from "./CustomSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb01304",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('feb01304')) {
      api.createRecord('feb01304', component.options)
    } else {
      api.reload('feb01304', component.options)
    }
    module.hot.accept("./CustomSettings.vue?vue&type=template&id=feb01304&scoped=true", function () {
      api.rerender('feb01304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/custom-settings/CustomSettings.vue"
export default component.exports